const config = {
  times: 5000,
  imgIp: window.__config.VUE_APP_IMG_URL + "/",
  imgIps: "http://121.37.201.53:9015/",
  imgWlw: "https://iot.joinken.cn.com",
  baseMap:
    window.__config.VUE_APP_MAP_URL + "/rest/services/440800/zj_05/MapServer",
  zoom: {
    maxZoom: 3,
    minZoom: 0
  },
  extent: {
    xmax: 113.13201878830836,
    xmin: 107.42131237431568,
    ymax: 22.571730046400404,
    ymin: 19.784786343321684,
    spatialReference: {
      wkid: 4326
    }
  },
  areaArr: [
    {
      name: "生猪标准化区",
      sta: "right",
      color: "#5BCBD5",
      code: "yzq",
      lat: -0.003086090087890625,
      lng: 0.0022678375244140625,
      rings: [
        [
          [-0.0028820037841796875, 0.0021820068359375],
          [-0.0028820037841796875, 0.0021533966064453125],
          [-0.0028743743896484375, 0.002140045166015625],
          [-0.0028696060180664062, 0.002132415771484375],
          [-0.0028657913208007812, 0.0021257400512695312],
          [-0.0028476715087890625, 0.0021104812622070312],
          [-0.0028285980224609375, 0.0020875930786132812],
          [-0.0028295516967773438, 0.0020704269409179688],
          [-0.0028409957885742188, 0.0020656585693359375],
          [-0.0028533935546875, 0.0020599365234375],
          [-0.00286102294921875, 0.0020599365234375],
          [-0.00286102294921875, 0.0020542144775390625],
          [-0.0028600692749023438, 0.0020475387573242188],
          [-0.0028581619262695312, 0.0020294189453125],
          [-0.0028553009033203125, 0.0020236968994140625],
          [-0.0028409957885742188, 0.0020151138305664062],
          [-0.0028362274169921875, 0.0020112991333007812],
          [-0.0028295516967773438, 0.002002716064453125],
          [-0.0028209686279296875, 0.0020017623901367188],
          [-0.0028095245361328125, 0.0019989013671875],
          [-0.0027980804443359375, 0.001995086669921875],
          [-0.0027828216552734375, 0.0019845962524414062],
          [-0.0027790069580078125, 0.001979827880859375],
          [-0.0027780532836914062, 0.0019712448120117188],
          [-0.0027818679809570312, 0.001964569091796875],
          [-0.0027933120727539062, 0.0019559860229492188],
          [-0.002803802490234375, 0.0019512176513671875],
          [-0.0028047561645507812, 0.0019397735595703125],
          [-0.0028162002563476562, 0.0019130706787109375],
          [-0.002819061279296875, 0.0019102096557617188],
          [-0.002819061279296875, 0.0019016265869140625],
          [-0.0028181076049804688, 0.0018930435180664062],
          [-0.0028142929077148438, 0.0018720626831054688],
          [-0.0028047561645507812, 0.0018711090087890625],
          [-0.0027933120727539062, 0.001861572265625],
          [-0.0027828216552734375, 0.001861572265625],
          [-0.0027637481689453125, 0.0018634796142578125],
          [-0.0027589797973632812, 0.0018596649169921875],
          [-0.002758026123046875, 0.0018625259399414062],
          [-0.0027561187744140625, 0.0018596649169921875],
          [-0.0027561187744140625, 0.0018529891967773438],
          [-0.0027627944946289062, 0.0018444061279296875],
          [-0.0027627944946289062, 0.0018377304077148438],
          [-0.00276947021484375, 0.0018310546875],
          [-0.0027780532836914062, 0.0018205642700195312],
          [-0.002788543701171875, 0.0018205642700195312],
          [-0.0028009414672851562, 0.0018291473388671875],
          [-0.0028066635131835938, 0.0018320083618164062],
          [-0.0028429031372070312, 0.0018320083618164062],
          [-0.002841949462890625, 0.00182342529296875],
          [-0.0028486251831054688, 0.0018167495727539062],
          [-0.002864837646484375, 0.0018053054809570312],
          [-0.00286865234375, 0.0017986297607421875],
          [-0.0028753280639648438, 0.0017786026000976562],
          [-0.0028858184814453125, 0.0017671585083007812],
          [-0.0028886795043945312, 0.0017633438110351562],
          [-0.0029010772705078125, 0.0017604827880859375],
          [-0.002941131591796875, 0.00177001953125],
          [-0.00298309326171875, 0.0017795562744140625],
          [-0.0029916763305664062, 0.0017910003662109375],
          [-0.003009796142578125, 0.0018024444580078125],
          [-0.0030164718627929688, 0.0018148422241210938],
          [-0.00301361083984375, 0.0018320083618164062],
          [-0.0030059814453125, 0.00186920166015625],
          [-0.00301361083984375, 0.0018835067749023438],
          [-0.0030260086059570312, 0.0018892288208007812],
          [-0.0030364990234375, 0.001880645751953125],
          [-0.0030517578125, 0.0018768310546875],
          [-0.0030565261840820312, 0.0018873214721679688],
          [-0.0030641555786132812, 0.0018987655639648438],
          [-0.0030603408813476562, 0.00191497802734375],
          [-0.0030660629272460938, 0.0019359588623046875],
          [-0.003063201904296875, 0.0019464492797851562],
          [-0.0030689239501953125, 0.0019578933715820312],
          [-0.0030679702758789062, 0.0019683837890625],
          [-0.0030765533447265625, 0.0019731521606445312],
          [-0.00310516357421875, 0.001995086669921875],
          [-0.0031280517578125, 0.0020036697387695312],
          [-0.0031595230102539062, 0.0020151138305664062],
          [-0.0031766891479492188, 0.0020151138305664062],
          [-0.00318145751953125, 0.0020093917846679688],
          [-0.0031909942626953125, 0.00200653076171875],
          [-0.0031976699829101562, 0.0020132064819335938],
          [-0.0032062530517578125, 0.0020122528076171875],
          [-0.0032129287719726562, 0.0020036697387695312],
          [-0.0032243728637695312, 0.0019989013671875],
          [-0.003215789794921875, 0.0019931793212890625],
          [-0.0032196044921875, 0.001979827880859375],
          [-0.003231048583984375, 0.00197601318359375],
          [-0.003231048583984375, 0.0019598007202148438],
          [-0.0032320022583007812, 0.001956939697265625],
          [-0.0032444000244140625, 0.0019512176513671875],
          [-0.0032510757446289062, 0.0019254684448242188],
          [-0.0032625198364257812, 0.0019197463989257812],
          [-0.0032720565795898438, 0.0019130706787109375],
          [-0.003269195556640625, 0.00189971923828125],
          [-0.0032625198364257812, 0.0018930435180664062],
          [-0.0032501220703125, 0.0018796920776367188],
          [-0.0032558441162109375, 0.0018749237060546875],
          [-0.003265380859375, 0.001873016357421875],
          [-0.003276824951171875, 0.001857757568359375],
          [-0.003284454345703125, 0.001850128173828125],
          [-0.0032949447631835938, 0.001834869384765625],
          [-0.0033063888549804688, 0.0018339157104492188],
          [-0.003307342529296875, 0.0018301010131835938],
          [-0.0033063888549804688, 0.001827239990234375],
          [-0.0033159255981445312, 0.00182342529296875],
          [-0.003326416015625, 0.001827239990234375],
          [-0.0033388137817382812, 0.0018415451049804688],
          [-0.0033502578735351562, 0.0018482208251953125],
          [-0.003345489501953125, 0.0018634796142578125],
          [-0.00336456298828125, 0.0018625259399414062],
          [-0.0033769607543945312, 0.0018749237060546875],
          [-0.0033826828002929688, 0.0018777847290039062],
          [-0.0033903121948242188, 0.00188446044921875],
          [-0.003414154052734375, 0.0018911361694335938],
          [-0.0034341812133789062, 0.0018701553344726562],
          [-0.00345611572265625, 0.00186920166015625],
          [-0.003459930419921875, 0.0018711090087890625],
          [-0.0034694671630859375, 0.00188446044921875],
          [-0.0034837722778320312, 0.0018787384033203125],
          [-0.00350189208984375, 0.0018825531005859375],
          [-0.00350189208984375, 0.0018968582153320312],
          [-0.0035161972045898438, 0.0019025802612304688],
          [-0.0035266876220703125, 0.0019235610961914062],
          [-0.0035400390625, 0.0019254684448242188],
          [-0.0035572052001953125, 0.0019254684448242188],
          [-0.0035734176635742188, 0.0019178390502929688],
          [-0.003566741943359375, 0.001941680908203125],
          [-0.0035619735717773438, 0.0019521713256835938],
          [-0.0035686492919921875, 0.00196075439453125],
          [-0.0035724639892578125, 0.0019655227661132812],
          [-0.003543853759765625, 0.0019922256469726562],
          [-0.0035429000854492188, 0.0020093917846679688],
          [-0.0035343170166015625, 0.00202178955078125],
          [-0.0035142898559570312, 0.002033233642578125],
          [-0.0034809112548828125, 0.00202178955078125],
          [-0.0035047531127929688, 0.0020618438720703125],
          [-0.0034923553466796875, 0.0020847320556640625],
          [-0.0034542083740234375, 0.0021276473999023438],
          [-0.003475189208984375, 0.0021572113037109375],
          [-0.0034694671630859375, 0.002170562744140625],
          [-0.0034694671630859375, 0.0021839141845703125],
          [-0.0034742355346679688, 0.0022077560424804688],
          [-0.0034732818603515625, 0.0022211074829101562],
          [-0.0034809112548828125, 0.002223968505859375],
          [-0.0034894943237304688, 0.002223968505859375],
          [-0.0034971237182617188, 0.00222015380859375],
          [-0.00351715087890625, 0.002193450927734375],
          [-0.0035371780395507812, 0.0021829605102539062],
          [-0.0035448074340820312, 0.0021848678588867188],
          [-0.003528594970703125, 0.002227783203125],
          [-0.0035371780395507812, 0.0022363662719726562],
          [-0.0035467147827148438, 0.0022401809692382812],
          [-0.003566741943359375, 0.0022401809692382812],
          [-0.0035991668701171875, 0.0022411346435546875],
          [-0.003612518310546875, 0.0022411346435546875],
          [-0.0036249160766601562, 0.0022459030151367188],
          [-0.0036344528198242188, 0.0022487640380859375],
          [-0.0036401748657226562, 0.0022459030151367188],
          [-0.0036458969116210938, 0.0022363662719726562],
          [-0.003665924072265625, 0.0022325515747070312],
          [-0.003665924072265625, 0.0022125244140625],
          [-0.0036764144897460938, 0.00220489501953125],
          [-0.0036783218383789062, 0.002193450927734375],
          [-0.0036783218383789062, 0.0021848678588867188],
          [-0.003692626953125, 0.0021715164184570312],
          [-0.0037050247192382812, 0.0021619796752929688],
          [-0.0037078857421875, 0.0021524429321289062],
          [-0.0037031173706054688, 0.0021314620971679688],
          [-0.0037031173706054688, 0.0021152496337890625],
          [-0.003711700439453125, 0.002101898193359375],
          [-0.0037145614624023438, 0.0020999908447265625],
          [-0.0037298202514648438, 0.0020732879638671875],
          [-0.003726959228515625, 0.0020551681518554688],
          [-0.0037212371826171875, 0.0020236968994140625],
          [-0.0037364959716796875, 0.0019941329956054688],
          [-0.0037555694580078125, 0.0019903182983398438],
          [-0.003765106201171875, 0.0019674301147460938],
          [-0.003772735595703125, 0.0019435882568359375],
          [-0.0037670135498046875, 0.0019207000732421875],
          [-0.0037631988525390625, 0.0019073486328125],
          [-0.003780364990234375, 0.0018911361694335938],
          [-0.0037822723388671875, 0.0018720626831054688],
          [-0.0037794113159179688, 0.0018711090087890625],
          [-0.0037813186645507812, 0.0018606185913085938],
          [-0.0038175582885742188, 0.0018672943115234375],
          [-0.003826141357421875, 0.0018444061279296875],
          [-0.003818511962890625, 0.0018281936645507812],
          [-0.0038118362426757812, 0.0018167495727539062],
          [-0.00380706787109375, 0.0018310546875],
          [-0.003787994384765625, 0.0018253326416015625],
          [-0.0037631988525390625, 0.0018253326416015625],
          [-0.0037622451782226562, 0.0018157958984375],
          [-0.00377655029296875, 0.0018024444580078125],
          [-0.0037870407104492188, 0.0018062591552734375],
          [-0.0037984848022460938, 0.0018100738525390625],
          [-0.0038003921508789062, 0.00177764892578125],
          [-0.0037832260131835938, 0.0017795562744140625],
          [-0.003780364990234375, 0.00177764892578125],
          [-0.0037794113159179688, 0.00177764892578125],
          [-0.003810882568359375, 0.0016756057739257812],
          [-0.0037937164306640625, 0.001750946044921875],
          [-0.0038204193115234375, 0.0017385482788085938],
          [-0.0038204193115234375, 0.0017271041870117188],
          [-0.0038242340087890625, 0.0017251968383789062],
          [-0.0038213729858398438, 0.001720428466796875],
          [-0.0038118362426757812, 0.001708984375],
          [-0.0037937164306640625, 0.0017147064208984375],
          [-0.0037927627563476562, 0.0016927719116210938],
          [-0.003803253173828125, 0.0016851425170898438],
          [-0.0038080215454101562, 0.0016851425170898438],
          [-0.0038137435913085938, 0.00167083740234375],
          [-0.0038204193115234375, 0.0016689300537109375],
          [-0.0038309097290039062, 0.0016689300537109375],
          [-0.0038423538208007812, 0.0016756057739257812],
          [-0.0038366317749023438, 0.0016984939575195312],
          [-0.0038471221923828125, 0.0017108917236328125],
          [-0.0038547515869140625, 0.0017042160034179688],
          [-0.0038537979125976562, 0.0016918182373046875],
          [-0.0038547515869140625, 0.0016765594482421875],
          [-0.0038690567016601562, 0.0016851425170898438],
          [-0.0038766860961914062, 0.0016851425170898438],
          [-0.0038776397705078125, 0.0016946792602539062],
          [-0.0038595199584960938, 0.001712799072265625],
          [-0.003864288330078125, 0.0017261505126953125],
          [-0.003864288330078125, 0.001735687255859375],
          [-0.0038776397705078125, 0.001750946044921875],
          [-0.0038881301879882812, 0.00176239013671875],
          [-0.00389862060546875, 0.0017728805541992188],
          [-0.0039052963256835938, 0.0017910003662109375],
          [-0.003914833068847656, 0.0018024444580078125],
          [-0.003912925720214844, 0.001827239990234375],
          [-0.0039119720458984375, 0.0018491744995117188],
          [-0.0039119720458984375, 0.0018606185913085938],
          [-0.0039157867431640625, 0.0018749237060546875],
          [-0.003930091857910156, 0.0018854141235351562],
          [-0.003947257995605469, 0.00189208984375],
          [-0.0039577484130859375, 0.0018968582153320312],
          [-0.003996849060058594, 0.0019102096557617188],
          [-0.004009246826171875, 0.0019197463989257812],
          [-0.004009246826171875, 0.0019254684448242188],
          [-0.004009246826171875, 0.0019321441650390625],
          [-0.0039691925048828125, 0.0019521713256835938],
          [-0.003958702087402344, 0.0019712448120117188],
          [-0.0039424896240234375, 0.0020189285278320312],
          [-0.0039424896240234375, 0.0020360946655273438],
          [-0.0039386749267578125, 0.0020418167114257812],
          [-0.003948211669921875, 0.002048492431640625],
          [-0.003968238830566406, 0.0020551681518554688],
          [-0.0039844512939453125, 0.002063751220703125],
          [-0.003994941711425781, 0.0020666122436523438],
          [-0.0040073394775390625, 0.0020666122436523438],
          [-0.0040283203125, 0.0020656585693359375],
          [-0.004034996032714844, 0.0020551681518554688],
          [-0.004047393798828125, 0.0020589828491210938],
          [-0.004052162170410156, 0.0020647048950195312],
          [-0.0040683746337890625, 0.0020494461059570312],
          [-0.0040740966796875, 0.00205230712890625],
          [-0.0040798187255859375, 0.0020542144775390625],
          [-0.0041103363037109375, 0.0021104812622070312],
          [-0.004105567932128906, 0.0021209716796875],
          [-0.00409698486328125, 0.0021333694458007812],
          [-0.004096031188964844, 0.0021352767944335938],
          [-0.004108428955078125, 0.0021638870239257812],
          [-0.004126548767089844, 0.002208709716796875],
          [-0.004117012023925781, 0.0022497177124023438],
          [-0.004109382629394531, 0.0022563934326171875],
          [-0.004092216491699219, 0.0022592544555664062],
          [-0.0040740966796875, 0.0022411346435546875],
          [-0.0040645599365234375, 0.002246856689453125],
          [-0.004058837890625, 0.0022821426391601562],
          [-0.004055023193359375, 0.0022954940795898438],
          [-0.004055976867675781, 0.0023164749145507812],
          [-0.004065513610839844, 0.002346038818359375],
          [-0.004076957702636719, 0.002361297607421875],
          [-0.004082679748535156, 0.0023651123046875],
          [-0.004103660583496094, 0.0023860931396484375],
          [-0.004123687744140625, 0.0024023056030273438],
          [-0.004146575927734375, 0.0024290084838867188],
          [-0.004151344299316406, 0.00244903564453125],
          [-0.0041561126708984375, 0.002460479736328125],
          [-0.0041561126708984375, 0.0024824142456054688],
          [-0.00415802001953125, 0.0025148391723632812],
          [-0.004151344299316406, 0.0025482177734375],
          [-0.004146575927734375, 0.0025720596313476562],
          [-0.004130363464355469, 0.0025882720947265625],
          [-0.004122734069824219, 0.0026044845581054688],
          [-0.0041179656982421875, 0.002620697021484375],
          [-0.004128456115722656, 0.0026388168334960938],
          [-0.0041332244873046875, 0.0026454925537109375],
          [-0.0041217803955078125, 0.0026493072509765625],
          [-0.004113197326660156, 0.0026502609252929688],
          [-0.004097938537597656, 0.0026941299438476562],
          [-0.00408935546875, 0.0027179718017578125],
          [-0.004092216491699219, 0.0027408599853515625],
          [-0.0040721893310546875, 0.0027532577514648438],
          [-0.004059791564941406, 0.002758026123046875],
          [-0.004019737243652344, 0.002727508544921875],
          [-0.0040283203125, 0.00273895263671875],
          [-0.0039958953857421875, 0.002750396728515625],
          [-0.0039730072021484375, 0.0027456283569335938],
          [-0.003970146179199219, 0.0027256011962890625],
          [-0.003966331481933594, 0.0027027130126953125],
          [-0.003964424133300781, 0.0026836395263671875],
          [-0.00396728515625, 0.00266265869140625],
          [-0.003960609436035156, 0.0026311874389648438],
          [-0.003943443298339844, 0.0026178359985351562],
          [-0.0039234161376953125, 0.0026187896728515625],
          [-0.003910064697265625, 0.0026073455810546875],
          [-0.0038862228393554688, 0.0026121139526367188],
          [-0.0038843154907226562, 0.0026264190673828125],
          [-0.0038785934448242188, 0.0026340484619140625],
          [-0.0038709640502929688, 0.0026788711547851562],
          [-0.0038661956787109375, 0.0026950836181640625],
          [-0.0038442611694335938, 0.0026950836181640625],
          [-0.00382232666015625, 0.0026912689208984375],
          [-0.003826141357421875, 0.00270843505859375],
          [-0.0038290023803710938, 0.0027313232421875],
          [-0.0038156509399414062, 0.0027322769165039062],
          [-0.0038118362426757812, 0.002712249755859375],
          [-0.0037946701049804688, 0.0026798248291015625],
          [-0.0037841796875, 0.002685546875],
          [-0.00377655029296875, 0.0026922225952148438],
          [-0.003765106201171875, 0.00267791748046875],
          [-0.003749847412109375, 0.0026760101318359375],
          [-0.0037364959716796875, 0.0026826858520507812],
          [-0.0037212371826171875, 0.0026865005493164062],
          [-0.0037021636962890625, 0.0026731491088867188],
          [-0.0036802291870117188, 0.0026865005493164062],
          [-0.0036716461181640625, 0.0026903152465820312],
          [-0.003665924072265625, 0.00269317626953125],
          [-0.0036525726318359375, 0.0026922225952148438],
          [-0.0036373138427734375, 0.002689361572265625],
          [-0.0036268234252929688, 0.0026884078979492188],
          [-0.0036163330078125, 0.00269317626953125],
          [-0.0036144256591796875, 0.002696990966796875],
          [-0.0036296844482421875, 0.0027141571044921875],
          [-0.00363922119140625, 0.0027265548706054688],
          [-0.00360870361328125, 0.002719879150390625],
          [-0.0035839080810546875, 0.0027341842651367188],
          [-0.003582000732421875, 0.00274658203125],
          [-0.00357818603515625, 0.0027523040771484375],
          [-0.0035963058471679688, 0.0027780532836914062],
          [-0.0036077499389648438, 0.00279998779296875],
          [-0.003612518310546875, 0.0028200149536132812],
          [-0.003612518310546875, 0.0028247833251953125],
          [-0.0035963058471679688, 0.0028285980224609375],
          [-0.0035562515258789062, 0.0028257369995117188],
          [-0.00354766845703125, 0.0028247833251953125],
          [-0.003536224365234375, 0.0028181076049804688],
          [-0.0035104751586914062, 0.0027666091918945312],
          [-0.0035228729248046875, 0.0027608871459960938],
          [-0.0035228729248046875, 0.0027570724487304688],
          [-0.0034999847412109375, 0.002758026123046875],
          [-0.003498077392578125, 0.0027523040771484375],
          [-0.003490447998046875, 0.0027360916137695312],
          [-0.0034933090209960938, 0.00272369384765625],
          [-0.0034933090209960938, 0.0027179718017578125],
          [-0.0034809112548828125, 0.002716064453125],
          [-0.0034704208374023438, 0.0027179718017578125],
          [-0.0034646987915039062, 0.00270843505859375],
          [-0.0034532546997070312, 0.0026998519897460938],
          [-0.003452301025390625, 0.0026884078979492188],
          [-0.0034236907958984375, 0.0026531219482421875],
          [-0.0034112930297851562, 0.0026493072509765625],
          [-0.0033931732177734375, 0.0026340484619140625],
          [-0.0033864974975585938, 0.00262451171875],
          [-0.0033769607543945312, 0.002620697021484375],
          [-0.0033664703369140625, 0.002620697021484375],
          [-0.003360748291015625, 0.002620697021484375],
          [-0.00335693359375, 0.0026187896728515625],
          [-0.0033550262451171875, 0.002593994140625],
          [-0.0033445358276367188, 0.0025777816772460938],
          [-0.0033445358276367188, 0.0025691986083984375],
          [-0.0033349990844726562, 0.0025768280029296875],
          [-0.0033178329467773438, 0.002590179443359375],
          [-0.0033054351806640625, 0.00260162353515625],
          [-0.0032949447631835938, 0.00261688232421875],
          [-0.0032949447631835938, 0.0026445388793945312],
          [-0.0032806396484375, 0.0026712417602539062],
          [-0.0032596588134765625, 0.0026884078979492188],
          [-0.0032644271850585938, 0.0027017593383789062],
          [-0.0032215118408203125, 0.002716064453125],
          [-0.0032186508178710938, 0.0027294158935546875],
          [-0.0032196044921875, 0.002765655517578125],
          [-0.0032196044921875, 0.002780914306640625],
          [-0.00321197509765625, 0.0028018951416015625],
          [-0.0031986236572265625, 0.0028095245361328125],
          [-0.0031824111938476562, 0.0028085708618164062],
          [-0.0031719207763671875, 0.0028009414672851562],
          [-0.003162384033203125, 0.0027914047241210938],
          [-0.0031270980834960938, 0.0027437210083007812],
          [-0.0031118392944335938, 0.002716064453125],
          [-0.0030975341796875, 0.0027151107788085938],
          [-0.0030841827392578125, 0.0027103424072265625],
          [-0.0030765533447265625, 0.0027170181274414062],
          [-0.003070831298828125, 0.0027093887329101562],
          [-0.0030660629272460938, 0.002727508544921875],
          [-0.0030469894409179688, 0.0027294158935546875],
          [-0.003040313720703125, 0.0027399063110351562],
          [-0.0030364990234375, 0.0027570724487304688],
          [-0.0030040740966796875, 0.0027456283569335938],
          [-0.0029020309448242188, 0.0027608871459960938],
          [-0.002895355224609375, 0.0027599334716796875],
          [-0.0028820037841796875, 0.0027599334716796875],
          [-0.0028696060180664062, 0.0027532577514648438],
          [-0.0028638839721679688, 0.002742767333984375],
          [-0.0028705596923828125, 0.0027360916137695312],
          [-0.0029039382934570312, 0.0027179718017578125],
          [-0.0029172897338867188, 0.0027132034301757812],
          [-0.0029211044311523438, 0.002704620361328125],
          [-0.0029382705688476562, 0.002689361572265625],
          [-0.0029449462890625, 0.0026674270629882812],
          [-0.0029420852661132812, 0.002628326416015625],
          [-0.0029363632202148438, 0.0026187896728515625],
          [-0.0029296875, 0.0026111602783203125],
          [-0.0029230117797851562, 0.0025959014892578125],
          [-0.002887725830078125, 0.00258636474609375],
          [-0.0028791427612304688, 0.0025796890258789062],
          [-0.0028715133666992188, 0.0025606155395507812],
          [-0.0028667449951171875, 0.0025472640991210938],
          [-0.0028638839721679688, 0.00254058837890625],
          [-0.0028333663940429688, 0.0025014877319335938],
          [-0.0028142929077148438, 0.0024938583374023438],
          [-0.0027780532836914062, 0.0024852752685546875],
          [-0.0027685165405273438, 0.0024728775024414062],
          [-0.0027608871459960938, 0.0024595260620117188],
          [-0.0027217864990234375, 0.0024309158325195312],
          [-0.0027189254760742188, 0.002422332763671875],
          [-0.00272369384765625, 0.0024127960205078125],
          [-0.0027265548706054688, 0.0024042129516601562],
          [-0.0027313232421875, 0.002391815185546875],
          [-0.002727508544921875, 0.002376556396484375],
          [-0.002727508544921875, 0.0023593902587890625],
          [-0.0027132034301757812, 0.00234222412109375],
          [-0.0026483535766601562, 0.0023565292358398438],
          [-0.0025911331176757812, 0.0023450851440429688],
          [-0.0025835037231445312, 0.002323150634765625],
          [-0.00258636474609375, 0.0023040771484375],
          [-0.002605438232421875, 0.0022993087768554688],
          [-0.0026178359985351562, 0.002288818359375],
          [-0.0026140213012695312, 0.0022783279418945312],
          [-0.0026044845581054688, 0.0022516250610351562],
          [-0.0026187896728515625, 0.0022306442260742188],
          [-0.0026292800903320312, 0.0022249221801757812],
          [-0.0026407241821289062, 0.002223968505859375],
          [-0.0026597976684570312, 0.002216339111328125],
          [-0.0026502609252929688, 0.0022068023681640625],
          [-0.0026521682739257812, 0.002201080322265625],
          [-0.0026683807373046875, 0.0021953582763671875],
          [-0.0026788711547851562, 0.0021696090698242188],
          [-0.0026912689208984375, 0.0021686553955078125],
          [-0.0027036666870117188, 0.0021762847900390625],
          [-0.0027284622192382812, 0.0021829605102539062],
          [-0.0027418136596679688, 0.0021762847900390625],
          [-0.0027418136596679688, 0.0021696090698242188],
          [-0.0027828216552734375, 0.0021648406982421875],
          [-0.0027952194213867188, 0.0021419525146484375],
          [-0.0028162002563476562, 0.0021486282348632812],
          [-0.0028247833251953125, 0.0021495819091796875],
          [-0.0028390884399414062, 0.0021467208862304688],
          [-0.0028400421142578125, 0.0021600723266601562],
          [-0.0028600692749023438, 0.0021657943725585938],
          [-0.0028705596923828125, 0.0021877288818359375],
          [-0.0028858184814453125, 0.0021848678588867188]
        ]
      ]
    }
  ],
  shArr: [
    {
      id: "jd1",
      name: "基地1",
      fwcolor: "#fff",
      wxname: "1号 网箱",
      wxcolor: "#FCFF29",
      zs: [12493843.148443226, 2477748.7696394846],
      zm: [12493186.267731376, 2478310.1040659677],
      yz: [12494046.184299607, 2478467.75543681],
      wx: [
        [
          [12493950.638014248, 2477990.024010015],
          [12494366.264355559, 2477784.5994964936],
          [12493826.427843282, 2477550.511097364],
          [12493950.638014248, 2477990.024010015]
        ]
      ]
    },
    {
      id: "jd1",
      name: "基地1",
      fwcolor: "#fff",
      wxname: "1号 网箱",
      wxcolor: "#FCFF29",
      zs: [12446415.763885329, 2460247.078819245],
      zm: [12446783.617083961, 2460968.453273705],
      yz: [12447175.356853932, 2460643.5959034846],
      wx: [
        [
          [12446979.486968948, 2461040.1129877246],
          [12447127.583711253, 2460543.272303858],
          [12446496.978227884, 2460562.3815609296],
          [12446979.486968948, 2461040.1129877246]
        ]
      ]
    },
    {
      id: "jd1",
      name: "基地1",
      fwcolor: "#fff",
      wxname: "1号 网箱",
      wxcolor: "#FCFF29",
      zs: [12408290.407370992, 2452906.735446754],
      zm: [12407831.785201268, 2453513.4543587836],
      yz: [12407803.121315662, 2453179.042360027],
      wx: [
        [
          [12408108.86942881, 2453322.361788065],
          [12408706.033712303, 2453007.0590463807],
          [12408161.419885756, 2452854.1849898063],
          [12408108.86942881, 2453322.361788065]
        ]
      ]
    },
    {
      id: "jd1",
      name: "基地1",
      fwcolor: "#fff",
      wxname: "1号 网箱",
      wxcolor: "#FCFF29",
      zs: [12407320.612574633, 2457727.0455429703],
      zm: [12407655.02457339, 2458199.9996554973],
      yz: [12407339.721831705, 2457985.0205134396],
      wx: [
        [
          [12407315.835260365, 2457975.465884904],
          [12407812.675944231, 2457779.595999918],
          [12407215.511660738, 2457555.062229324],
          [12407315.835260365, 2457975.465884904]
        ]
      ]
    },
    {
      id: "jd1",
      name: "基地1",
      fwcolor: "#fff",
      wxname: "1号 网箱",
      wxcolor: "#FCFF29",
      zs: [12402942.20404831, 2454340.054214756],
      zm: [12403138.073933296, 2454502.4828998665],
      yz: [12403221.676932985, 2454371.106757498],
      wx: [
        [
          [12402894.43090563, 2454476.2076713927],
          [12403147.628561832, 2454335.2769004884],
          [12402772.609391797, 2454220.6213580575],
          [12402894.43090563, 2454476.2076713927]
        ]
      ]
    }
  ],
  sh: [
    {
      id: "jd1",
      name: "基地1",
      color: "#fff",
      ring:
        "[[[12492782.584675744,2478197.8371807053],[12494105.900727967,2478957.4301493093],[12495070.918210093,2477323.5886696707],[12494316.102555757,2476392.0123874205],[12492782.584675744,2478197.8371807053]]]"
    },
    {
      id: 2,
      name: "基地2",
      color: "#fff",
      ring:
        "[[[12446793.1717125, 2461579.9495000015],[12447636.367680792, 2460865.7410169435],[12447199.243425274, 2460017.767734383],[12446549.528684832, 2460266.1880763164],[12446334.549542774, 2459282.061337119],[12445627.507031117, 2459563.922878928],[12446793.1717125, 2461579.9495000015]]]"
    },
    {
      id: 3,
      name: "基地3",
      color: "#fff",
      ring:
        "[[[12407354.053774474, 2453580.336758535],[12407769.680115785, 2453675.8830438936],[12409059.554968132, 2452806.4118471267],[12408557.936969997, 2451922.608707556],[12407354.053774474, 2453580.336758535]]]"
    },
    {
      id: 4,
      name: "基地4",
      color: "#fff",
      ring:
        "[[[12407712.352344604, 2458639.512568149],[12406661.343205657, 2458051.902913191],[12407081.746861236, 2456771.5826893807],[12408342.957827974, 2457153.7678308166],[12407712.352344604, 2458639.512568149]]]"
    },
    {
      id: 5,
      name: "基地5",
      color: "#fff",
      ring:
        "[[[12402562.407564009, 2454464.264385723],[12403219.288275851, 2454581.3085852875],[12403302.89127554, 2454246.8965865313],[12402485.97053572, 2454062.969987215],[12402562.407564009, 2454464.264385723]]]"
    }
  ],
  sb: [
    {
      code: "sb",
      type: "point",
      longitude: 12494046.184299607,
      latitude: 2478467.75543681,
      name: "",
      tc_pic: "fy.png",
      class: "sb",
      classType: "育种基地"
    },
    {
      code: "jd",
      type: "point",
      longitude: 12447175.35685393,
      latitude: 2460643.5959034846,
      name: "",
      tc_pic: "fy.png",
      class: "jd",
      classType: "育种基地"
    },
    {
      code: "jd",
      type: "point",
      longitude: 12407803.12131566,
      latitude: 2453179.042360027,
      name: "",
      tc_pic: "fy.png",
      class: "jd",
      classType: "育种基地"
    },
    {
      code: "jd",
      type: "point",
      longitude: 12407339.7218317,
      latitude: 2457985.0205134396,
      name: "",
      tc_pic: "fy.png",
      class: "jd",
      classType: "育种基地"
    },
    {
      code: "jd",
      type: "point",
      longitude: 12403221.67693298,
      latitude: 2454371.106757498,
      name: "",
      tc_pic: "fy.png",
      class: "jd",
      classType: "育种基地"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12493186.267731376,
      latitude: 2478310.1040659677,
      name: "",
      tc_pic: "bz.png",
      class: "sb",
      classType: "保障基地"
    },
    {
      code: "jd",
      type: "point",
      longitude: 12446783.617083961,
      latitude: 2460968.453273705,
      name: "",
      tc_pic: "bz.png",
      class: "jd",
      classType: "保障基地"
    },
    {
      code: "jd",
      type: "point",
      longitude: 12407831.785201268,
      latitude: 2453513.4543587836,
      name: "",
      tc_pic: "bz.png",
      class: "jd",
      classType: "保障基地"
    },
    {
      code: "jd",
      type: "point",
      longitude: 12407655.02457339,
      latitude: 2458199.9996554973,
      name: "",
      tc_pic: "bz.png",
      class: "jd",
      classType: "保障基地"
    },
    {
      code: "jd",
      type: "point",
      longitude: 12403138.073933296,
      latitude: 2454502.4828998665,
      name: "",
      tc_pic: "bz.png",
      class: "jd",
      classType: "保障基地"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12494676.789782977,
      latitude: 2477488.4060118804,
      name: "",
      tc_pic: "sz.png",
      class: "sb",
      classType: "水质设备"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12446310.662971435,
      latitude: 2459745.4608211103,
      name: "",
      tc_pic: "sz.png",
      class: "sb",
      classType: "水质设备"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12408796.802683394,
      latitude: 2452949.7312751655,
      name: "",
      tc_pic: "sz.png",
      class: "sb",
      classType: "水质设备"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12407836.562515572,
      latitude: 2457626.7219433435,
      name: "",
      tc_pic: "sz.png",
      class: "sb",
      classType: "水质设备"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12402722.447591985,
      latitude: 2454404.5479573733,
      name: "",
      tc_pic: "sz.png",
      class: "sb",
      classType: "水质设备"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12493993.63384266,
      latitude: 2477110.9981847126,
      name: "",
      tc_pic: "jk.png",
      class: "sb",
      classType: "水质设备"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12446191.230114736,
      latitude: 2460180.1964194938,
      name: "",
      tc_pic: "jk.png",
      class: "sb",
      classType: "水质设备"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12408557.936969997,
      latitude: 2452691.756304696,
      name: "",
      tc_pic: "jk.png",
      class: "sb",
      classType: "水质设备"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12407435.268117065,
      latitude: 2457512.0664009126,
      name: "",
      tc_pic: "jk.png",
      class: "sb",
      classType: "水质设备"
    },
    {
      code: "sb",
      type: "point",
      longitude: 12402741.556849055,
      latitude: 2454237.341957995,
      name: "",
      tc_pic: "jk.png",
      class: "sb",
      classType: "水质设备"
    }
  ],
  wx: [
    {
      name: "1号 网箱",
      color: "#FCFF29",
      ring:
        "[[[12493950.638014248, 2477990.024010015],[12494366.264355559, 2477784.5994964936],[12493826.427843282, 2477550.511097364],[12493950.638014248, 2477990.024010015]]]"
    },
    {
      name: "2号 网箱",
      color: "#FCFF29",
      ring:
        "[[[12446979.486968948, 2461040.1129877246],[12447127.583711253, 2460543.272303858],[12446496.978227884, 2460562.3815609296],[12446979.486968948, 2461040.1129877246]]]"
    },
    {
      name: "3号 网箱",
      color: "#FCFF29",
      ring:
        "[[[12408108.86942881,2453322.361788065],[12408706.033712303,2453007.0590463807],[12408161.419885756,2452854.1849898063],[12408108.86942881,2453322.361788065]]]"
    },
    {
      name: "4号 网箱",
      color: "#FCFF29",
      ring:
        "[[[12407315.835260365, 2457975.465884904],[12407812.675944231, 2457779.595999918],[12407215.511660738, 2457555.062229324],[12407315.835260365, 2457975.465884904]]]"
    },
    {
      name: "5号 网箱",
      color: "#FCFF29",
      ring:
        "[[[12402894.43090563, 2454476.2076713927],[12403147.628561832, 2454335.2769004884],[12402772.609391797, 2454220.6213580575],[12402894.43090563, 2454476.2076713927]]]"
    }
  ],
  wx2: [
    {
      name: "1号 网箱",
      color: "#FCFF29",
      longitude: 12493950.638014248,
      latitude: 2477990.024010015
    },
    {
      name: "2号 网箱",
      color: "#FCFF29",
      longitude: 12446979.486968948,
      latitude: 2461040.1129877246
    },
    {
      name: "3号 网箱",
      color: "#FCFF29",
      longitude: 12408108.86942881,
      latitude: 2453322.361788065
    },
    {
      name: "4号 网箱",
      color: "#FCFF29",
      longitude: 12407315.835260365,
      latitude: 2457975.465884904
    },
    {
      name: "5号 网箱",
      color: "#FCFF29",
      longitude: 12402894.43090563,
      latitude: 2454476.2076713927
    }
  ],
  //schj 1118 修改成了茂名市的地图了
  zhwlCity: "茂名市",
  tileMapUrl:
    window.__config.VUE_APP_MAP_URL +
    "/rest/services/440900/mm_bd_03/MapServer",
  tileMapUrlColor:
    window.__config.VUE_APP_MAP_URL +
    "/rest/services/440900/mm_as_01/MapServer",
  resolutions: [
    // 0.00237946100583028,
    0.0019035688046642242,
    0.00118973050291514,
    5.9486525145757e-4,
    2.97432625728785e-4
    // 1.5228550437313792e-4
  ],
  sLat: 22.03118528348074,
  sLng: 110.81697802523058,
  sZoom: 0,
  mZoom: 3,
  schjLxMap:
    "http://cache1.arcgisonline.cn/arcgis/rest/services/SimpleFeature/ChinaBoundaryLine/MapServer", ///tile/{z}/{y}/{x}
  schjlxMapZooms: 1,
  schjlxMapZooml: 4
};
export default config;
